var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column flex-1" },
    [
      _c("b-pagination", {
        attrs: { "total-rows": _vm.total_rows, "per-page": _vm.per_page },
        on: { input: _vm.page_changed },
        model: {
          value: _vm.model_page_curr,
          callback: function ($$v) {
            _vm.model_page_curr = $$v
          },
          expression: "model_page_curr",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }